import React from 'react';
import NotebookNav from './NotebookNav/NotSmall';
import { ScrollView } from '../../components/ui';

const NotebookLayoutNS: React.FC = ({ children }) => (
  <div className="fixed absolute--fill flex flex-column">
    <NotebookNav />
    <ScrollView
      className="relative flex-auto flex flex-column ph2 ph3-m ph4-l"
      scrollWithKeyboard
      data-testid="notebook-layout-scrollview"
    >
      {children}
    </ScrollView>
  </div>
);

export default NotebookLayoutNS;
